import { inject, Injectable } from '@angular/core';
import { type Observable, shareReplay, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';

@Injectable({
    providedIn: 'root',
})
export class DataLayerHttpService {
    protected readonly http: HttpClient = inject(HttpClient);
    private url = '/members/ajax/data-layer';

    public getDataLayer(): Observable<any> {
        return this.http.get(`${location.origin}${this.url}`).pipe(
            shareReplay(),
            map((res) => {
                return res;
            }),
            catchError((error) => throwError(error))
        );
    }
}
